export default {
  leastDrawn: 'Menos sorteado',
  mostDrawn: 'Mais sorteado',
  leastPlayed: 'Menos jogado',
  mostPlayed: 'Mais jogado',
  drawFrom: 'Sorteio de',
  h: 'h', // abreviação para horas
  startingIn: 'Começando em',
  waitingForDrawnFrom: 'Aguardando sorteio de',
  displayingDrawFrom: 'Exibindo sorteio de',
  lotteryDraw: 'Sorteio da loteria',
  eventId: 'ID do Evento',
  bettingShortcuts: 'Atalhos de apostas',
  draw: 'Sorteio',
  next5Events: 'Próximos {value} em exibição',
  events: 'Eventos',
  schedule: 'Agenda',
  next: 'Próximo',
  event: 'Evento',
  later: 'Mais tarde',
  statistics: 'Estatísticas',
  lastnRounds: 'Últimas {value} rodadas',
  bettingOffer: 'Oferta de apostas',
  notDisplayed: 'Não exibido',
  latestResults: 'Últimos resultados',
  drawnAt: 'Sorteado às {value}',
  additionalBetting: 'Apostas adicionais',
  drawSumEvenOdd: 'Soma do sorteio Par ou Ímpar',
  drawSumTotal: 'Soma total do sorteio',
  drawSumRange: 'Faixa da soma do sorteio',
  waitingForDrawNo: 'Aguardando sorteio Nº {value}',
  nextDraw: 'Próximo sorteio',
  waitingForDraw: 'Aguardando sorteio',
  drawCompleted: 'Sorteio concluído',
  drawDisplayTemporarilyNotAvailable: 'Exibição do sorteio temporariamente indisponível',
  connectionError: 'Erro de conexão!',
  reconnecting: 'Reconectando...',
  number: 'Número',
  headerNumberDescriptionUp: 'Evento',
  headerNumberDescriptionDown: 'Número',
};
